import { render, staticRenderFns } from "./VideoEditorOne.vue?vue&type=template&id=b8456a48&scoped=true&"
import script from "./VideoEditorOne.vue?vue&type=script&lang=ts&"
export * from "./VideoEditorOne.vue?vue&type=script&lang=ts&"
import style0 from "./VideoEditorOne.vue?vue&type=style&index=0&id=b8456a48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8456a48",
  null
  
)

export default component.exports